"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Icon_1 = __importDefault(require("../Icon/Icon"));
var styles_1 = require("./styles");
var EditableTitle = function (_a) {
    var Component = _a.Component, isEditing = _a.isEditing, onEditingPenClick = _a.onEditingPenClick, onChange = _a.onChange, onEscape = _a.onEscape, onEnter = _a.onEnter, _b = _a.maxLength, maxLength = _b === void 0 ? NaN : _b, _c = _a.value, value = _c === void 0 ? '' : _c, rest = __rest(_a, ["Component", "isEditing", "onEditingPenClick", "onChange", "onEscape", "onEnter", "maxLength", "value"]);
    var ref = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            ref.current.textContent = value;
        }
    }, [ref]);
    (0, react_1.useEffect)(function () {
        if (ref.current && !isEditing) {
            ref.current.textContent = value;
        }
    }, [value]);
    var handleOnKeyDown = function (e) {
        var _a, _b, _c;
        (_a = rest.onKeyDown) === null || _a === void 0 ? void 0 : _a.call(rest, e);
        if (e.key === 'Enter') {
            e.preventDefault();
            e.currentTarget.blur();
            onEnter === null || onEnter === void 0 ? void 0 : onEnter();
        }
        if (e.key === 'Escape' || e.key === 'Tab') {
            e.preventDefault();
            e.currentTarget.blur();
            onEscape === null || onEscape === void 0 ? void 0 : onEscape();
        }
        if ((((_c = (_b = e.currentTarget) === null || _b === void 0 ? void 0 : _b.textContent) === null || _c === void 0 ? void 0 : _c.length) || 0) >= maxLength && e.key !== 'Backspace') {
            e.preventDefault();
        }
    };
    // Select all text when editing starts
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d, _e;
        if (isEditing) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            // put cursor at the end of the text
            var range = document.createRange();
            var sel = window.getSelection();
            if ((_b = ref.current) === null || _b === void 0 ? void 0 : _b.lastChild) {
                range.setStart(ref.current.lastChild, ((_d = (_c = ref.current) === null || _c === void 0 ? void 0 : _c.textContent) === null || _d === void 0 ? void 0 : _d.length) || 0);
                range.collapse(true);
                sel === null || sel === void 0 ? void 0 : sel.removeAllRanges();
                sel === null || sel === void 0 ? void 0 : sel.addRange(range);
                (_e = ref.current) === null || _e === void 0 ? void 0 : _e.focus();
            }
        }
    }, [isEditing]);
    (0, react_1.useEffect)(function () {
        if (ref.current) {
            var eventListener_1 = function () {
                var _a;
                onChange === null || onChange === void 0 ? void 0 : onChange(((_a = ref.current) === null || _a === void 0 ? void 0 : _a.textContent) || '');
            };
            ref.current.addEventListener('input', eventListener_1);
            return function () {
                var _a;
                (_a = ref.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('input', eventListener_1);
            };
        }
        return function () { return null; };
    }, [ref]);
    var isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
    var contentEditable = isFirefox ? 'true' : 'plaintext-only';
    return ((0, jsx_runtime_1.jsxs)(styles_1.Container, { children: [(0, jsx_runtime_1.jsx)(Component, __assign({ ref: ref, contentEditable: (isEditing ? contentEditable : false), suppressContentEditableWarning: true, onKeyDown: handleOnKeyDown, onBlur: onEscape }, rest, { style: { paddingRight: '8px', paddingLeft: '8px' }, "aria-label": "Editable ".concat(value), role: isEditing ? 'textbox' : 'heading', "aria-multiline": "false" })), onEditingPenClick && ((0, jsx_runtime_1.jsx)(styles_1.PenContainer, __assign({ onClick: onEditingPenClick }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { name: "edit-outline" }) })))] }));
};
exports.default = EditableTitle;
